var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0203 10.0782L13.8757 12.9328L12.9323 13.8762L10.0777 11.0208C9.0155 11.8723 7.69434 12.3354 6.33301 12.3335C3.02101 12.3335 0.333008 9.6455 0.333008 6.3335C0.333008 3.0215 3.02101 0.333496 6.33301 0.333496C9.64501 0.333496 12.333 3.0215 12.333 6.3335C12.3349 7.69483 11.8718 9.01599 11.0203 10.0782ZM9.68301 9.5835C10.5291 8.71342 11.0016 7.54712 10.9997 6.3335C10.9997 3.75483 8.91101 1.66683 6.33301 1.66683C3.75434 1.66683 1.66634 3.75483 1.66634 6.3335C1.66634 8.9115 3.75434 11.0002 6.33301 11.0002C7.54663 11.0021 8.71293 10.5296 9.58301 9.6835L9.68301 9.5835Z",
    fill: "#425466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5580ad17245aaecafa5834d07365c2ea.svg";
export { ForwardRef as ReactComponent };